
<!--Cards-->
<ng-container *ngIf="CardView">
  <div fxLayoutGap="20px" class="card card-class">
    <h5 class="card-title"><mat-icon>event_seat</mat-icon>Exam/s</h5>
    <div class="card-body card-details">
      <ng-container *ngIf="examData.length <= 0">
        <div class="profile-card">
          <img src="/assets/exams_img.svg">
          <div class="header">
            <h3>This space is empty!</h3>
            No Exam available to display. Use the button below to add one or more exams.
            We promise you would not see this again after you have successfully added an exam.
          </div>
        </div>
        <div class="form-group buttons">
          <button (click)="openDialogExam()" class="btn btn-primary next">Add Exam</button>
        </div>
      </ng-container>
      
      <button *ngIf="examData.length > 0" class="btn add-new-user" (click)="openDialogExam()"><i class="fas fa-plus"></i>ADD EXAM</button>
      <!--<button class="btn add-new-user" (click)="download()"><i class="fas fa-download"></i>DOWNLOAD EXAM</button>-->
      <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
        <div fxFlex="20%" *ngFor="let exam of examData">
          <mat-card class="mat-elevation-z4" (click)="Select(exam)">
            <mat-card-content>
              <p>
                {{exam.description}}
              </p>
            </mat-card-content>
            <mat-card-actions>
              <mat-icon (click)="reGenarateExam(exam)" >autorenew</mat-icon>
              <mat-icon (click)="editExam(exam)">edit</mat-icon>
              <mat-icon (click)="deleteExam(exam)">delete</mat-icon>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!--List-->
<ng-container *ngIf="ListView">

  <mat-drawer-container class="Custom-Container" >
    <mat-drawer style="width:25%;" mode="side" opened>
      <div style="display:flex;justify-content:space-between;">
        <h5><mat-icon>event_seat</mat-icon>Exam/s</h5>
        <button (click)="openDialogExam()"><i class="fas fa-plus"></i>ADD EXAM</button>
      </div>
      <div>
        <div *ngFor="let exam of examData">
          <mat-card style="display:flex;justify-content:space-between;" class="mat-elevation-z4" (click)="Select(exam)">
            <mat-card-content>
              <p>
                {{exam.description}}
              </p>
            </mat-card-content>
            <mat-card-actions>
              <mat-icon (click)="reGenarateExam(exam)">autorenew</mat-icon>
              <mat-icon (click)="editExam(exam)">edit</mat-icon>
              <mat-icon (click)="deleteExam(exam)">delete</mat-icon>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>

    </mat-drawer>

    <mat-drawer-content>


      <ng-container *ngIf="SelectedExam.papers">
        <div fxLayoutGap="20px" class="card card-class">
          <h5 class="card-title"><mat-icon>event_seat</mat-icon>{{CurrentClass?.className}}  Paper/s</h5>
          <div class="card-body card-details">
            <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
              <div fxFlex="20%" *ngFor="let p of SelectedExam.papers">
                <mat-card class="mat-elevation-z4">
                  <mat-card-content>
                    <p>
                      {{p.subject}}
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a [href]="DownloadExam(p.sysref)">ExamPaper</a><br />
                    <a [href]="DownloadPaper(p.sysref)">AnswerSheet</a>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </mat-drawer-content>
  </mat-drawer-container>
</ng-container>
  

